import { z } from 'zod';

// --- Personality profile dimension types ---
const PersonalityTemplate = {
    AutomotiveStandard: 'AUTOMOTIVE_STANDARD',
    PowersportsStandard: 'POWERSPORTS_STANDARD',
    MarineStandard: 'MARINE_STANDARD',
    AgriculturalStandard: 'AGRICULTURAL_STANDARD',
    RvStandard: 'RV_STANDARD',
    Friendly: 'FRIENDLY',
    Casual: 'CASUAL',
    Energetic: 'ENERGETIC',
    Empathetic: 'EMPATHETIC',
    Custom: 'CUSTOM',
};
const PersonalityTone = {
    PolishedAuthoritative: 'POLISHED_AUTHORITATIVE',
    WarmApproachable: 'WARM_APPROACHABLE',
    RelaxedConversational: 'RELAXED_CONVERSATIONAL',
    UpbeatEnthusiastic: 'UPBEAT_ENTHUSIASTIC',
    CaringUnderstanding: 'CARING_UNDERSTANDING',
};
const PersonalityFormality = {
    High: 'HIGH',
    Moderate: 'MODERATE',
    Low: 'LOW',
};
const PersonalityEmojiUsage = {
    None: 'NONE',
    Occasional: 'OCCASIONAL',
    Frequent: 'FREQUENT',
};
const PersonalityTypoSimulation = {
    None: 'NONE',
    Light: 'LIGHT',
};
const PersonalityResponseLength = {
    Concise: 'CONCISE',
    Short: 'SHORT',
    Moderate: 'MODERATE',
    Thorough: 'THOROUGH',
};
const PersonalityFollowUpStyle = {
    Structured: 'STRUCTURED',
    Conversational: 'CONVERSATIONAL',
    LaidBack: 'LAID_BACK',
    Proactive: 'PROACTIVE',
    Supportive: 'SUPPORTIVE',
};
const PersonalitySlangUsage = {
    None: 'NONE',
    Light: 'LIGHT',
    Moderate: 'MODERATE',
};
const PersonalityDialect = {
    GeneralAmerican: 'GENERAL_AMERICAN',
    Northeast: 'NORTHEAST',
    NewYorkMidAtlantic: 'NEW_YORK_MID_ATLANTIC',
    Southern: 'SOUTHERN',
    Texan: 'TEXAN',
    Midwestern: 'MIDWESTERN',
    Appalachian: 'APPALACHIAN',
    GulfCoastCajun: 'GULF_COAST_CAJUN',
    CaliforniaWestCoast: 'CALIFORNIA_WEST_COAST',
    PacificNorthwest: 'PACIFIC_NORTHWEST',
    Hawaiian: 'HAWAIIAN',
    Alaskan: 'ALASKAN',
    PuertoRican: 'PUERTO_RICAN',
};
const personalityProfileSchema = z
    .object({
    template: z.nativeEnum(PersonalityTemplate).optional(),
    tone: z.nativeEnum(PersonalityTone).default(PersonalityTone.PolishedAuthoritative),
    formality: z.nativeEnum(PersonalityFormality).default(PersonalityFormality.High),
    emojiUsage: z.nativeEnum(PersonalityEmojiUsage).default(PersonalityEmojiUsage.None),
    typoSimulation: z
        .nativeEnum(PersonalityTypoSimulation)
        .default(PersonalityTypoSimulation.None),
    slangUsage: z.nativeEnum(PersonalitySlangUsage).default(PersonalitySlangUsage.None),
    dialect: z.nativeEnum(PersonalityDialect).default(PersonalityDialect.GeneralAmerican),
    responseLength: z
        .nativeEnum(PersonalityResponseLength)
        .default(PersonalityResponseLength.Concise),
    followUpStyle: z
        .nativeEnum(PersonalityFollowUpStyle)
        .default(PersonalityFollowUpStyle.Structured),
})
    .optional();

export { PersonalityDialect, PersonalityEmojiUsage, PersonalityFollowUpStyle, PersonalityFormality, PersonalityResponseLength, PersonalitySlangUsage, PersonalityTemplate, PersonalityTone, PersonalityTypoSimulation, personalityProfileSchema };
//# sourceMappingURL=AiBdcSettings.js.map
